import bannerBg from '../../assets/img/home4/promo-banner-bg.jpg';

const PlansTwo = () => {
    return (
        <section className="plans-two-wrapper bg-cover" style={{ backgroundImage: `url(${bannerBg})` }}>

            {/* Top navy heading strip */}
            <div className="plans-two-heading-strip">
                <div className="container">
                    <h2>Unleash the Extraordinary AMC Plan for Professional <br className="d-none d-md-block" /> Maintenance Services</h2>
                </div>
            </div>

            {/* Primary-color subtitle strip */}
            <div className="plans-two-subtitle-strip">
                <div className="container">
                    <h3>Customise your AMC Plan</h3>
                </div>
            </div>

            {/* Feature card */}
            <div className="container plans-two-body">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-6 col-md-8">
                        <div className="plans-two-card">

                            {/* AMC Features List */}
                            <ul className="plans-two-checklist">
                                <li><i className="fas fa-circle"></i> Unlimited Callouts (No Service Visit Charges)</li>
                                <li><i className="fas fa-circle"></i> Same-Day Emergency Response Across UAE</li>
                                <li><i className="fas fa-circle"></i> 4 Scheduled Maintenance Visits Per Year (Quarterly)</li>
                                <li><i className="fas fa-circle"></i> Complete AC Working Condition Inspection</li>
                                <li><i className="fas fa-circle"></i> Cooling Performance &amp; Airflow Check</li>
                                <li><i className="fas fa-circle"></i> Gas Level Check &amp; Minor Top-Up (If Required)</li>
                                <li><i className="fas fa-circle"></i> Filter Cleaning at Every Visit</li>
                                <li><i className="fas fa-circle"></i> Thermostat &amp; Electrical Component Inspection</li>
                                <li><i className="fas fa-circle"></i> Compressor &amp; Outdoor Unit Check</li>
                                <li><i className="fas fa-circle"></i> Drain Line Inspection</li>
                            </ul>

                            {/* CTA */}
                            <a
                                href="https://wa.me/971502033924"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="theme-btn plans-two-btn"
                            >
                                Customise Your Plan
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    );
};

export default PlansTwo;
